// src/App.js
//
// Top-level entry for waka-demo — the Demo Day Check-Out app (demo.waka.surf).
// This repo is demo-only: the app always renders DemoFlow. The flavor
// (config/flavor.js) still selects which Firestore collections are used and
// whether the DEMO PREVIEW banner shows:
//   - REACT_APP_FLAVOR=demo         → demo* collections        (demo.waka.surf)
//   - REACT_APP_FLAVOR=demo_preview → demo*_demo_preview + banner
//     (waka-demo-preview.web.app)
//
// SPEC: waka-registration/docs/SPEC-2026-07-22-demo-checkout.md
// Split out of waka-registration into its own repo 2026-07-22.

import React from 'react';
import DemoFlow from './components/demo/DemoFlow';
import DemoWaiverPublic from './components/demo/DemoWaiverPublic';

function App() {
  // Public waiver page (Nigel 2026-07-22): /waiver renders the full waiver text
  // unauthenticated — linkable from emails, the site, and printed signage.
  // Routed here at the top level so DemoFlow's hooks stay unconditional
  // (an early return inside DemoFlow violated react-hooks/rules-of-hooks).
  if (typeof window !== 'undefined' && window.location.pathname === '/waiver') {
    return <DemoWaiverPublic />;
  }
  return <DemoFlow />;
}

export default App;
